import React from 'react';
import { TextField, MenuItem, Grid, Button, Typography, Card, CardContent } from '@mui/material';

const degreeFields = {
  "CA (ICAI)": [
    { label: "CA Level", name: "ProfessionalCourse", options: ["Foundation/CPT", "Inter/PE", "Final"] },
    { label: "Attempts", name: "PC_Attempt", options: ["First Attempt", "Second Attempt"] },
    { label: "Institution", name: "institution" },
    { label: "Start Date", name: "startDate", type: "date" },
    { label: "End Date", name: "endDate", type: "date" },
    { label: "Marks", name: "marks" },
    { label: "Description", name: "description" },
    { label: "Rank", name: "rank" }
  ],
  "CFA": [
    { label: "CFA Level", name: "ProfessionalCourse", options: ["Level 1", "Level 2", "Level 3"] },
    { label: "Attempts", name: "PC_Attempt", options: ["First Attempt", "Second Attempt"] },
    { label: "Institution", name: "institution" },
    { label: "Start Date", name: "startDate", type: "date" },
    { label: "End Date", name: "endDate", type: "date" }
  ],
  "MBA (Finance)": [
    { label: "Institution", name: "institution" },
    { label: "Course Type", name: "ProfessionalCourse", options: ["2 Year Full Time", "1 Year Full Time", "Executive", "MDP"] },
    { label: "Start Date", name: "startDate", type: "date" },
    { label: "End Date", name: "endDate", type: "date" },
    { label: "Rank", name: "rank" },
    { label: "Marks", name: "marks" }
  ],
  "B.Com": [
    { label: "Institution", name: "institution" },
    { label: "University", name: "university" },
    { label: "Start Date", name: "startDate", type: "date" },
    { label: "End Date", name: "endDate", type: "date" },
    { label: "Rank", name: "rank" },
    { label: "Marks", name: "marks" }
  ]
};

const EducationDetails = ({ formData = { education: [] }, setFormData }) => {
  const handleChange = (index, field, event) => {
    const newEducations = [...formData.education];
    newEducations[index] = { ...newEducations[index], [field]: event.target.value };
    setFormData({ ...formData, education: newEducations });
  };

  const addEducation = () => {
    setFormData({ ...formData, education: [...formData.education, {}] });
  };

  const removeEducation = (index) => {
    const newEducations = formData.education.filter((_, i) => i !== index);
    setFormData({ ...formData, education: newEducations });
  };

  return (
    <Grid container spacing={2}>
      {formData.education.map((education, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6">Education {index + 1}</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Degree"
                    name="degree"
                    value={education.degree || ''}
                    onChange={(e) => handleChange(index, "degree", e)}
                    select
                  >
                    {Object.keys(degreeFields).map((degree) => (
                      <MenuItem key={degree} value={degree}>{degree}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {degreeFields[education.degree]?.map((field) => (
                  <Grid item xs={12} key={field.name}>
                    <TextField
                      fullWidth
                      label={field.label}
                      name={field.name}
                      value={education[field.name] || ''}
                      onChange={(e) => handleChange(index, field.name, e)}
                      select={field.options !== undefined}
                      type={field.type || 'text'}
                    >
                      {field.options?.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Button variant="contained" color="secondary" onClick={() => removeEducation(index)}>
                    Remove
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={addEducation}>
          Add Education
        </Button>
      </Grid>
    </Grid>
  );
};

export default EducationDetails;
